// import {  RavenToggleSlide, RavenToolTip } from "@ravenpay/raven-bank-ui";
import React, { useState } from "react";
import "./PreviewFragment.css";
import { RavenNumberFormat } from "@ravenpay/raven-bank-ui";

interface MyComponentProps {
  collapse?: boolean;
  amount?: string;
  card_fee?: string;
  landmark?: string;
  quantity?: string;
  reason?: string;
  address?: string;
  state?: string;
  lga?: string;
  details?: any;
  manualCompType?: boolean;
  manualList?: any;
  logoImg?: any;
}

const PreviewRequestPosDetailsBox = ({
  collapse,
  amount,
  card_fee,
  landmark,
  quantity,
  reason,
  address,
  state,
  lga,
  manualList,
  details,
  manualCompType,
  logoImg,
}: MyComponentProps) => {
  const [showDetail, setShowDetail] = useState(false);
  const heightTop = "8rem";
  return (
    <div
      className={`new-preview-detail-box-wrap new-preview-detail-box-wrap-funding-amount-box card-bg border-theme`}
      style={
        {
          "--height-val": heightTop,
          marginTop: logoImg ? "5rem" : "10rem",
        } as React.CSSProperties
      }
    >
      {/* top box start */}
      {/* img top box start */}
      <div
       
        className="img-top-box-wrap"
      >
        {logoImg ? (
          <>
            {" "}
            <div className="img-wrap">
              <figure className="img-box">
                <img src={logoImg} alt="" className="img" />
              </figure>
              {/* <div className="arrow-wrap grey-bg">
            <div className="arrow-box">
              <FaArrowRight className="icon" />
            </div>
          </div> */}
            </div>
          </>
        ) : (
          <>
            {" "}
            {/* amount date box styart */}
            <div
              style={{ marginTop: "0rem" }}
              className="amount-date-box funding-amount-box grey-bg-two"
            >
              <p className="label ">{`Total Amount`}</p>
              <p className="value ">
                <span>
                  {
                    RavenNumberFormat(
                      amount || details?.amount || "0",
                      {}
                    )?.split(".")[0]
                  }
                </span>
                <span>.</span>
                <span className="decimal ">
                  {
                    RavenNumberFormat(amount || details?.amount || "0")?.split(
                      "."
                    )[1]
                  }
                </span>
              </p>
            </div>
            {/* amount date box end */}
          </>
        )}
      </div>
      {/* img top box end */}
      {/* top box end */}
      {/* middle-content start */}
      <div
        className="middle-box middle-content-wrap "
        style={{ borderBottom: "unset", paddingBottom: "unset", marginTop: logoImg ? "-3rem" : "" }}
        // onClick={() => {
        //   console.log(manualList);
        // }}
      >
        {manualCompType ? (
          <>
            {manualList?.map((chi: any, idx: any) => {
              if (!chi?.value) {
                return <React.Fragment key={idx}></React.Fragment>;
              }
              return (
                <div className="box">
                  <p className="label grey-white-color-white">
                    <span className="grey-white-color">{chi?.label}:</span>
                  </p>
                  <p className="value">
                    <span>{chi?.value || "---"}</span>
                  </p>
                </div>
              );
            })}
          </>
        ) : (
          <>
            {" "}
            <p className="text">
              <span className="grey-white-color">State:</span>{" "}
              <span>{state || "---"}</span>
            </p>
            <p className="text">
              <span className="grey-white-color">Lga:</span>{" "}
              <span>{lga || "----"}</span>
            </p>
            <p className="text">
              <span className="grey-white-color">Delivery address:</span>{" "}
              <span>{address || "---"}</span>
            </p>
            <p className="text">
              <span className="grey-white-color">Landmark:</span>{" "}
              <span>{landmark || "---"}</span>
            </p>
            <p className="text">
              <span className="grey-white-color">Quantity:</span>{" "}
              <span>{quantity || "---"}</span>
            </p>
            <p className="text">
              <span className="grey-white-color">Reason for : </span>{" "}
              <span>{reason || "---"}</span>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default PreviewRequestPosDetailsBox;
